import { BaseAction } from '../../store/actions';
import { RestoreApiOptions } from '../../shared/models/restore';

export enum RestorePasswordActions {
  RestorePassword = '[Password] Restore',
  RestorePasswordSuccess = '[Password] Restore Success',
  RestorePasswordError = '[Password] Restore Error',
  ResetState = '[Password] Reset State'
}

export class RestorePassword implements BaseAction<RestorePasswordActions> {
  readonly type = RestorePasswordActions.RestorePassword;

  constructor(public readonly apiOptions: RestoreApiOptions) { }
}

export class RestorePasswordSuccess implements BaseAction<RestorePasswordActions> {
  readonly type = RestorePasswordActions.RestorePasswordSuccess;

}

export class RestorePasswordError implements BaseAction<RestorePasswordActions> {
  readonly type = RestorePasswordActions.RestorePasswordError;

  constructor(public readonly payload: string) { }
}

export class ResetState implements BaseAction<RestorePasswordActions> {
  readonly type = RestorePasswordActions.ResetState;

}

export type RestorePasswordAction = RestorePassword | RestorePasswordSuccess | RestorePasswordError | ResetState;
